module.exports = __webpack_public_path__ + "static/media/financial-skills@2x.0c901cf8.png";